import type { Responsive } from '#types/common'
import type { ButtonVariant } from '#types/components/vf/button'
import type { ResponsiveColor } from '#types/content'
import type { TextLinkStyle } from '#types/styles'
import type { InjectionKey } from 'vue'

export interface RecommendationStyle extends TextLinkStyle {
  whiteBackground?: boolean
  textColor?: ResponsiveColor
  originalPriceColor?: ResponsiveColor
  salePriceColor?: ResponsiveColor
  ctaStyle?: Responsive<ButtonVariant>
}

export const RecommendationStyleContextKey: InjectionKey<RecommendationStyle> = Symbol('RecommendationStyle')
